import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AdminBuyerListPermissionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const adminBuyerListPermissionsQuery = graphql(`
  query adminBuyerListPermissions($id: String!) {
    adminBuyerListPermissions(id: $id) {
      objectId
      accessorId
      accessorType
      roleName
    }
  }
`);

/** Fetch all permission rows on a buyer list (admin — bypasses per-list RBAC). */
export function useAdminBuyerListPermissions(
  buyerListId: string,
  options?: UseQueryOptions<
    AdminBuyerListPermissionsQuery,
    unknown,
    AdminBuyerListPermissionsQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["adminBuyerListPermissions", buyerListId],
    adminBuyerListPermissionsQuery,
    [{ id: buyerListId }],
    options,
  );
  return { data: data?.adminBuyerListPermissions, ...rest };
}
